import {withLocalePath} from './i18n-utils'
import {privateDiscussionHref} from './private-discussion-location'
export function parseDiscussionFocus(value:unknown):string|undefined {
 if(value===undefined)return undefined
 if(typeof value!=='string'||! /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value))throw new Error('Invalid contribution link')
 return value
}
export function discussionEntryHref(locale:string,thread:string,entry:string,workspace?:string) {
 const base=workspace?privateDiscussionHref(withLocalePath('/community/private',locale),workspace,thread):withLocalePath(`/community/${thread}`,locale)
 return `${base}${workspace?'&':'?'}focus=${encodeURIComponent(entry)}#post-${encodeURIComponent(entry)}`
}

export function discussionLoginDestination(path:string,search:string) {
 return `${path}${search}#thread-comments-heading`
}
